import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import Toolbar, { ToolbarProps } from '@material-ui/core/Toolbar';

import TextFieldSearch, { TextFieldSearchProps } from './TextFieldSearch';

const messages = defineMessages({
  search: {
    id: 'components.v2.ToolbarSquigglies.search',
    defaultMessage: 'Search',
  },
});

export interface ToolbarSquiggliesProps extends Omit<ToolbarProps, 'classes'> {
  TextFieldSearchProps: Omit<TextFieldSearchProps, 'classes'>;
}

const ToolbarSquigglies: React.FC<ToolbarSquiggliesProps> = ({
  TextFieldSearchProps: TextFieldSearchPropsInner,
  ...rest
}) => {
  const { formatMessage } = useIntl();

  return (
    <Toolbar {...rest}>
      <TextFieldSearch
        autoFocus
        fullWidth
        placeholder={formatMessage(messages.search)}
        {...TextFieldSearchPropsInner}
      />
    </Toolbar>
  );
};

export default ToolbarSquigglies;
